import dayjs from 'dayjs'
import { ReservationType } from '@/models/reservation'
import { SalesType, SalesDiscountType } from '@/models/sales'

/**
 * 売上明細や割引の日付が全て宿泊期間内にあるかチェックする
 *
 * @param items 売上明細または割引の配列
 * @param reservations 予約の配列
 * @returns 全ての日付が宿泊期間内の場合true、1つでも期間外があればfalse
 */
export const isItemDatesInStayPeriod = (items: (SalesType | SalesDiscountType)[], reservations: ReservationType[]): boolean => {
  if (reservations.length === 0) {
    return false
  }

  // reservationsのcheckinDateのminを取得
  const minCheckinDate = reservations.reduce((min, reservation) => {
    return dayjs(reservation.checkinDate).isSameOrBefore(dayjs(min)) ? reservation.checkinDate : min
  }, reservations[0].checkinDate)

  // reservationsのcheckoutDateのmaxを取得
  const maxCheckoutDate = reservations.reduce((max, reservation) => {
    return dayjs(reservation.checkoutDate).isSameOrAfter(dayjs(max)) ? reservation.checkoutDate : max
  }, reservations[0].checkoutDate)

  // itemsの日付がminCheckinDateとmaxCheckoutDateの範囲内に全てあること
  return items.every(item => {
    const itemDate = dayjs(item.salesDate)
    return itemDate.isSameOrAfter(dayjs(minCheckinDate)) && itemDate.isSameOrBefore(dayjs(maxCheckoutDate))
  })
}
